import { useCallback, useEffect, useState } from "react";
import { useAuth } from "../context/AuthContext";
import { useMonth } from "../context/MonthContext";
import { incomeApi, ApiIncome } from "../services/api";

export const useMonthlyIncomes = (refreshTrigger?: number) => {
  const { user } = useAuth();
  const { selectedMonth, currentYear } = useMonth();
  const [incomes, setIncomes] = useState<ApiIncome[]>([]);
  const [totalIncome, setTotalIncome] = useState(0);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const refreshIncomes = useCallback(async () => {
    if (!user?.group_id) {
      setIncomes([]);
      setTotalIncome(0);
      return;
    }

    setLoading(true);
    setError(null);
    try {
      const monthStr = `${currentYear}-${String(selectedMonth + 1).padStart(2, "0")}`;
      const data = await incomeApi.getMonthlyIncomes(user.group_id, monthStr);
      setIncomes(data.incomes ?? []);
      setTotalIncome(data.total_income ?? 0);
    } catch (err: any) {
      setError(err.message || "Failed to load incomes");
      setIncomes([]);
      setTotalIncome(0);
    } finally {
      setLoading(false);
    }
  }, [currentYear, selectedMonth, user?.group_id]);

  useEffect(() => {
    refreshIncomes();
  }, [refreshIncomes, refreshTrigger]);

  return { incomes, totalIncome, loading, error, refreshIncomes };
};
